import history from "../history"
const logout = () => {
    localStorage.removeItem('jwt')
    localStorage.removeItem('roles')
    history.push('/auth/login')
}
export default logout